module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加分类")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "分类类型"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "分类名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.cate_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "cate_name", $$v)
      },
      expression: "params.cate_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cate_id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.sort),
            expression: "scope.row.sort"
          }],
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "placeholder": "0"
          },
          domProps: {
            "value": (scope.row.sort)
          },
          on: {
            "change": function($event) {
              return _vm.saveSort(scope.$index, scope.row)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(scope.row, "sort", $event.target.value)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cate_name",
      "label": "分类名称",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.cate_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "front_show",
      "align": "center",
      "label": "前台是否显示",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "0",
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchAuth(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.front_show),
            callback: function($$v) {
              _vm.$set(scope.row, "front_show", $$v)
            },
            expression: "scope.row.front_show"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "分类描述",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分类类型",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("普通视频")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("短视频")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.page_size) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.page_size
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑分类",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "分类名称",
        "prop": "cate_name",
        "rules": [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标签名称"
      },
      model: {
        value: (_vm.form.cate_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "cate_name", $$v)
        },
        expression: "form.cate_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "分类说明"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入分类说明"
      },
      model: {
        value: (_vm.form.description),
        callback: function($$v) {
          _vm.$set(_vm.form, "description", $$v)
        },
        expression: "form.description"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "前台显示"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.front_show),
        callback: function($$v) {
          _vm.$set(_vm.form, "front_show", $$v)
        },
        expression: "form.front_show"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "0",
        "border": ""
      }
    }, [_vm._v("不显示")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "分类类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.type),
        callback: function($$v) {
          _vm.$set(_vm.form, "type", $$v)
        },
        expression: "form.type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("普通视频")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "2",
        "border": ""
      }
    }, [_vm._v("短视频")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveCateData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04dc6a9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04dc6a9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/category.vue
// module id = 2435
// module chunks = 0